const ticketFormDefaultValues = {
  shipper_id: '',
  shipper_data: {
    company_name: '',
    company_id: '',
    contact_name: '',
    phone: '',
    language: 'en',
  },
  order_data: {
    pickup: {
      company_name: '',
      address: '',
      city: '',
      zipcode: '',
      country: 'ES',
      date: '',
      time_from: '',
      time_to: '',
      observations: '',
    },
    dropoff: {
      company_name: '',
      address: '',
      city: '',
      zipcode: '',
      country: 'ES',
      date: '',
      time_from: '',
      time_to: '',
      observations: '',
    },
    loads_data: {
      loads: [
        {
          number_of_items: 1,
          load_type: 'eupallet',
          item_length: '',
          item_width: '',
          item_height: '',
        },
      ],
      totals: {
        total_weight: '',
        linear_meters: '',
        cubic_meters: '',
      },
    },
    service_type: {
      vehicle_type: 'Small van (max. 400kg)',
      vehicle_details: [],
    },
    complementary_info: {
      customer_internal_reference: '',
      customer_deadline_date: '',
      customer_deadline_time: '',
      additional_services: [],
    },
  },

  custom: {
    transport: {
      selected_notification_transport: 'email',
      email: '',
      phone: '',
    },
  },
};

export default ticketFormDefaultValues;
